import { render, staticRenderFns } from "./Colmenares.vue?vue&type=template&id=f8199c3a&"
import script from "./Colmenares.vue?vue&type=script&lang=js&"
export * from "./Colmenares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports